<template>
  <z-dialogo
    ref="dialogo"
    titulo="Pedidos de Compra"
    largura="800px"
    altura="400px"
    persistent
    scrollable
    no-padding
    :dividers="true"
  >

    <template #prepend>
      <v-toolbar flat color="white">
        <v-autocomplete
          v-model="filtro.fornecedor_id"
          single-line
          dense
          hide-details
          outlined
          label="Filtrar Fornecedor"
          filled
          disabled
          :items="$store.getters['listas/fornecedores']"
          @click:clear="filtro.fornecedor_id = null"
          @change="carregarPedidosCompras"
        ></v-autocomplete>
      </v-toolbar>

    </template>

    <template v-slot:texto>
      <v-data-table
        :headers="headers"
        :items="pedidoscompraStore.pedidoscompra"
        :loading="carregando"
        hide-default-footer
        disable-pagination
        disable-sort
        single-expand
      >
        <template v-slot:item="{ item: pedido, expand, isExpanded }">
          <tr style="cursor: pointer" @click="exibirProdutos(pedido)">
            <td>{{ pedido.id }}</td>
            <td>{{ pedido.data_emissao | dataBR }}</td>
            <td>{{ pedido.fornecedor.razao }}</td>
            <td class="text-center">{{ pedido.itens_count }}</td>
            <td class="text-center">
              <v-chip
                small
                dark
                :color="corChip(pedido.status)"
              >{{ pedido.status }}</v-chip>
            </td>
            <td class="text-center">
              <v-btn depressed small color="primary" @click.stop="exibirProdutos(pedido)">Produtos</v-btn>
              <v-btn icon @click.stop="perguntarExcluir(pedido)" v-if="$auth.can('pedidoscompra:excluir') && pedido.status !== 'Entregue'">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>


        <template #expanded-item="{ item, headers }">
          <tr>
            <td :colspan="headers.length" class="pa-4 grey lighten-3">
              <v-row dense>
                <v-col cols="12">
                  <v-card>

                    <v-data-table
                      v-model="selected"
                      hide-default-footer 
                      disable-pagination
                      disable-sort
                      dense
                      item-key="id" 
                      :headers="headers_itens" 
                      :items="item.itens"
                      show-select
                    >
                    
                      <template #item.index="{ index }">
                        {{ index + 1 }}
                      </template>

                      <template #item.quantidade="{ item }">
                        {{ item.quantidade | valorQTD(config.configuracoes.CASAS_DECIMAIS_QUANTIDADE) }} {{ item.unidade }}
                      </template>

                      <template #item.quantidade_entregue="{ item }">
                        {{ item.quantidade_entregue | valorQTD(config.configuracoes.CASAS_DECIMAIS_QUANTIDADE) }} {{ item.unidade }}
                      </template>


                      <template #item.opcoes="{ item }">
                        <v-btn v-if="item.agendamento?.length > 0" icon tabindex="-1" @click="$refs.dialogoExibirAgendamento.abrir(item)">
                          <v-icon>mdi-calendar</v-icon>
                        </v-btn>
                      </template>

                    </v-data-table>
                  </v-card>

                </v-col>
              </v-row>
            </td>
          </tr>
        </template>

      </v-data-table>
    </template>
    <template v-slot:actions_right>
      <v-btn text @click="fechar">Fechar</v-btn>
    </template>
    
    <DialogoExibirAgendamento 
      ref="dialogoExibirAgendamento"
    ></DialogoExibirAgendamento>

    <DialogoPedidosCompraProdutos
      ref="dialogoExibirProdutos"
      @onSelecionarProdutos="confirmar"
    ></DialogoPedidosCompraProdutos>

    <z-dialogo-sim-nao
      ref="dialogoRemoverPedidoCompra"
      titulo="Remover pedido de compra?"
      botaoSim="Remover"
      botaoNao="Cancelar"
      :loading="excluindo"
    >
      O pedido de compra será removido. Deseja continuar?
    </z-dialogo-sim-nao>
  </z-dialogo>

</template>

<script setup>

import { onMounted, ref, getCurrentInstance, inject } from "vue";
import { usePedidosCompraStore } from '@/app/store/pinia/pedidoscompra';
import { useConfigStore } from '@/app/store/pinia/configuracoes';
import DialogoExibirAgendamento from '@/pages/produtos/controle/DialogoExibirAgendamento.vue';
import DialogoPedidosCompraProdutos from '@/pages/estoque/DialogoPedidosCompraProdutos.vue';

const { proxy } = getCurrentInstance();
const $router = proxy.$router;
const $store = proxy.$store;
const $notificacao = inject("notificacao");

const pedidoscompraStore = usePedidosCompraStore();
const config = useConfigStore();

const dialogoExibirAgendamento = ref(null);
const dialogoExibirProdutos = ref(null);
const dialogoRemoverPedidoCompra = ref(null);
const excluindo = ref(false);

const headers = ref([
  { text: "Número", value: "id", width: "100px" },
  { text: "Data", value: "data" },
  { text: "Fornecedor", value: "fornecedor.razao" },
  { text: "Itens", value: "itens_count", align: "center" },
  { text: "Status", value: "status", align: "center" },
  { text: "Opções", value: "", align: "center", sortable: false },
])

const headers_itens = ref([
  { text: "Item", value: "index", width: "80px" },
  { text: "Referência", value: "referencia", width: "110px" },
  { text: "Descrição", value: "produto.descricao", sortable: false },
  { text: "Quantidade", value: "quantidade", align: "right" },
  { text: "Recebido", value: "quantidade_entregue", align: "right" },
  { text: "", value: "opcoes", align: "center" },
])

const dialogo = ref(null)
const movimentos = ref([])
const carregando = ref(false)
const filtro = ref({
  fornecedor_id: null,
});
const _fornecedor_id = ref(null);

const selected = ref([]); // Itens selecionados na tabela

function abrir(fornecedor_id = null) {
  _fornecedor_id.value = fornecedor_id;
  dialogo.value.abrir();
  carregarPedidosCompras(fornecedor_id);
}

function fechar() {
  dialogo.value.fechar();
}

async function carregarPedidosCompras(fornecedor_id = null) {
  try {
    carregando.value = true;
    if (fornecedor_id) {
      filtro.value.fornecedor_id = fornecedor_id;
    }
    movimentos.value = await pedidoscompraStore.listar(filtro.value);
    // if (movimentos.value.length === 0) {
    //   notificacao.adicionar({
    //     tipo: "info",
    //     mensagem: "Nenhum pedido de compra encontrado.",
    //   });
    // }
  } catch (error) {
    console.log(error);
  } finally {
    carregando.value = false;
  }
}

async function confirmar(pedido) {
  emit("confirmar", pedido);
  fechar();
}

function exibirProdutos(pedido) {
  dialogoExibirProdutos.value.abrir(pedido);
}


async function perguntarExcluir(pedido) {
  let response = await dialogoRemoverPedidoCompra.value.abrir();
  if (response == false) {
    return;
  }

  try {
    dialogoRemoverPedidoCompra.value.startLoading();
    excluindo.value = true;
    await $store.dispatch("pedidoscompra/excluir", pedido);
    $notificacao.notificar("Pedido removido com sucesso!");
    carregarPedidosCompras(_fornecedor_id.value);
    dialogoRemoverPedidoCompra.value.fechar();
  } catch (error) {
    $notificacao.erro("Não foi possível cancelar o pedido.", error);
    console.log(error);
  } finally {
    excluindo.value = false;
    dialogoRemoverPedidoCompra.value.stopLoading();
  }
}

function corChip(situacao) {
  const cores = {
    "Pendente": "orange",
    "Parcial": "cyan",
    "Cancelado": "red",
    "Entregue": "green"
  };
  return cores[situacao] || "";
}

const emit = defineEmits(["confirmar"]);

defineExpose({
  abrir,
  fechar,
});

</script>

<style scoped></style>
